import BaseApi from "./BaseApi";

export default class InscricaoService {

    static postNovaOpcaoCurso(command) {
        return BaseApi.post(`inscricao/v1/novaOpcaoCurso`, command);
    }

    static update(command) {
        return BaseApi.put(`inscricao/v1`, command);
    }

    static updateOpcaoIngresso(command) {
        return BaseApi.post(`inscricao/v1/opcaoIngresso/atualizarOpcaoIngresso`, command);
    }

    static async get() {
        return BaseApi.get(`inscricao/v1/getInscricoesResumo`).then(r => r.result);
    }

    static getPaginado(pagina, tamanhoPagina, sorted) {
        return BaseApi.get(`inscricao/v1/getListaPaginada/${pagina}/${tamanhoPagina}/${sorted}`);
    }

    static getUrlPagamento(cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`inscricao/v1/getUrlPagamentos/${cdEventoCadastro}/${nrOpcao}`);
    }

    static getUrlPagamentoSemInscricao() {
        return BaseApi.get(`inscricao/v1/getUrlPagamentos`);
    }

    static getUrlRecurly() {
        return BaseApi.get(`inscricao/v1/getUrlRecurly`);
    }

    static getCursosListOpcaoAtiva(cdEventoCadastro) {
        return BaseApi.get(`inscricao/v1/carregarCurso/${cdEventoCadastro}/true`);
    }    

    static getTurnosByCursoAndEventoCadastro(cdCurso, cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`inscricao/v1/carregarTurnos/${cdCurso}/${cdEventoCadastro}/${nrOpcao}`);
    }

    static getOpcaoIngressoByCursoAndLocalAndTurno(cdCurso, cdLocal, cdTurno) {
        return BaseApi.get(`inscricao/v1/opcaoIngresso/${cdCurso}/${cdLocal}/${cdTurno}`);
    }

    static getOpcaoIngressoTrocaByEventoCadastro(cdEventoCadastro, nrOpcao) {
        return BaseApi.get(`inscricao/v1/opcaoIngresso/GetOpcoesIngressoTroca/${cdEventoCadastro}/${nrOpcao}`);
    }

    static getValidarNumeroEnem(numeroEnem) {
        return BaseApi.get(`inscricao/v1/validaNumeroEnem/${numeroEnem}`);
    }

    static putAprovarCandidato(command) {
        return BaseApi.put(`inscricao/v1/AprovarCandidato`, command);
    }

    static putCancelarCandidato(command) {
        return BaseApi.post(`inscricao/v1/CancelarCandidato`, command);
    }
}